/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Back_To_MarketplaceInputs */

const en_back_to_marketplace = /** @type {(inputs: Back_To_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Back to Marketplace`)
};

const es_back_to_marketplace = /** @type {(inputs: Back_To_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Volver al mercado`)
};

const fr_back_to_marketplace = /** @type {(inputs: Back_To_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Retour à la marketplace`)
};

const de_back_to_marketplace = /** @type {(inputs: Back_To_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Zurück zum Marktplatz`)
};

const ja_back_to_marketplace = /** @type {(inputs: Back_To_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← マーケットプレイスに戻る`)
};

const zh_back_to_marketplace = /** @type {(inputs: Back_To_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← 返回市场`)
};

const ar_back_to_marketplace = /** @type {(inputs: Back_To_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← العودة إلى السوق`)
};

const id_back_to_marketplace = /** @type {(inputs: Back_To_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Kembali ke Marketplace`)
};

const it_back_to_marketplace = /** @type {(inputs: Back_To_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Torna al Marketplace`)
};

const ru_back_to_marketplace = /** @type {(inputs: Back_To_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Назад к Маркетплейсу`)
};

const pt_back_to_marketplace = /** @type {(inputs: Back_To_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Voltar ao Marketplace`)
};

const ko_back_to_marketplace = /** @type {(inputs: Back_To_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← 마켓플레이스로 돌아가기`)
};

/**
* | output |
* | --- |
* | "← Back to Marketplace" |
*
* @param {Back_To_MarketplaceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const back_to_marketplace = /** @type {((inputs?: Back_To_MarketplaceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Back_To_MarketplaceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_back_to_marketplace(inputs)
	if (locale === "es") return es_back_to_marketplace(inputs)
	if (locale === "fr") return fr_back_to_marketplace(inputs)
	if (locale === "de") return de_back_to_marketplace(inputs)
	if (locale === "ja") return ja_back_to_marketplace(inputs)
	if (locale === "zh") return zh_back_to_marketplace(inputs)
	if (locale === "ar") return ar_back_to_marketplace(inputs)
	if (locale === "id") return id_back_to_marketplace(inputs)
	if (locale === "it") return it_back_to_marketplace(inputs)
	if (locale === "ru") return ru_back_to_marketplace(inputs)
	if (locale === "pt") return pt_back_to_marketplace(inputs)
	return ko_back_to_marketplace(inputs)
});